<template>
  <div style="min-height: 100% !important">
    <v-row type="flex" justify="center">
      <v-col :xl="12" :lg="12" :md="12" :sm="14" :xs="24" offset="1" class="content-title" style="margin-top: 50px"
             align="middle">
        <v-row justify="space-around" style="max-width: 80%; margin: auto">
          <div class="mx-5 my-5">
                <v-btn icon @click="language = 'de'">
                  <De/>
                </v-btn><br>
            Deutschland
          </div>
          <div class="mx-5 my-5">
                <v-btn icon @click="language = 'en'">
                  <En/>
                </v-btn><br>
            GB/ US
          </div>
          <div class="mx-5 my-5">
                <v-btn icon @click="language = 'tr'">
                  <Tr/>
                </v-btn><br>
            Türkiye
          </div>
          <div class="mx-5 my-5">
                <v-btn icon @click="language = 'ru'">
                  <Ru/>
                </v-btn><br>
                Россия
          </div>
          <div class="mx-5 my-5">
                <v-btn icon @click="language = 'fr'">
                  <Fr/>
                </v-btn><br>
            France
          </div>
          <div class="mx-5 my-5">
                <v-btn icon @click="language = 'nl'">
                  <Nl/>
                </v-btn><br>
            Netherlands
          </div>
          <div class="mx-5 my-5">
                <v-btn icon @click="language = 'es'">
                  <Es/>
                </v-btn><br>
            Espana
          </div>
          <div class="mx-5 my-5">
                <v-btn icon @click="language = 'pl'">
                  <Pl/>
                </v-btn><br>Polska
          </div>
          <div class="mx-5 my-5">
            <v-btn icon @click="language = 'pt'">
              <Pt/>
            </v-btn><br>
            Portugal
          </div>
          <div class="mx-5 my-5">
            <v-btn icon @click="language = 'it'">
              <It/>
            </v-btn>
            <br>
            Italia
          </div>
          <div class="mx-5 my-5">
            <v-btn icon @click="language = 'cz'">
              <Cs/>
            </v-btn><br>
            Česká republika
          </div>
          <div class="mx-5 my-5">
            <v-btn icon @click="language = 'ar'">
              <Ar/>
            </v-btn><br>
            الامارات العربية المتحدة
          </div>
        </v-row>
        <h3 style="margin-top: 50px" class="text-center align-center">
          {{
            appTextsTranslations.title[language] ? appTextsTranslations.title[language] : appTextsTranslations.title['de']
          }}
        </h3>
        <h6 style="margin-top: 20px" class="text-center align-center" v-if="uuid && uuid != ''">
          USER-ID: {{ uuid }}
        </h6>
      </v-col>
      <v-col :xl="12" :lg="12" :md="12" :sm="14" :xs="24" offset="1" class="content-title" style="margin-top: 20px"
             align="middle">
        <img v-if="currentQuestion.question_id === 'a9bbd043-58c4-4930-a0a3-5b91cd14fdec'"
             :src="$store.state.url + 'Elephant_EdV_hello.png'" style="max-height: 200px"/>
        <img
            v-else-if="currentQuestion.question_id === '922df5f5-11e1-4b01-9af2-a4ed33234801' || currentQuestion.question_id === '9841ca89-9ebe-48cf-8a45-6566806ab44e'"
            :src="$store.state.url + 'Elephant_EdV_see_you.png'" style="max-height: 200px"/>
        <img v-else
             :src="$store.state.url + 'Elephant_EdV_letsgo.png'" style="max-height: 200px"/>
      </v-col>
      <v-col
          align-self="center"
          v-if="!uuid"
          :xl="12" :lg="12" :md="12" :sm="14" :xs="24" offset="1" class="content-title" style="margin-top: 50px">
        <h3 class="text-center">Nicht registriert</h3>
        <v-row justify="center">
          <v-text-field placeholder="USER-ID" style="max-width: 300px" class="text-center" v-model="userpassword"></v-text-field>
          <v-btn class="primary text-center" @click="checkUserPassword()">SEND</v-btn>
        </v-row>
        <p v-if="authError && authError.length > 0"> {{ authError }}</p>
      </v-col>
      <v-col cols="10" offset="1"
             style="min-height: 800px"
             v-if="questionsListParsed && questionsListParsed.length > 0 && uuid"
             :span="20"
             align-self="center"
      >
        <v-row justify="center">
          <h5 class="text-center">{{ questionTextTranslation }}</h5>
          <v-icon
              v-if="currentQuestion.commentText && currentQuestion.commentText.length > 0"
              style="margin-left: 20px;"
              @click="showCommentSidebar = true"
          >
            mdi-comment-question-outline
          </v-icon>
        </v-row>
        <v-row
            v-if="currentQuestion.commentText && currentQuestion.commentText.length > 0 && showCommentSidebar === true"
            justify="center">
          <v-card class="text-center" style="min-width: 300px; background-color: lightgreen">
            <v-card-title>
              <v-spacer/>
              <v-icon
                  aria-label="Close"
                  @click="showCommentSidebar = false"
              >
                mdi-close
              </v-icon>
            </v-card-title>
            <v-card-text
                align="center"
                style="width: 80%; margin: auto"
            >
              {{ commentTextTranslation }}
            </v-card-text>
          </v-card>
        </v-row>

        <v-row v-if="currentQuestion.type === 6" justify="center">
          <v-text-field
              justify="center"
              v-model="entry" style="width: 70%"
              :rules="[rules.required]" filled/>
        </v-row>
        <v-row v-if="currentQuestion.text.indexOf('Chargennummer') > 0" justify="center">
          <img
              style="width: 60%"
              :src="$store.state.url + 'chargennummer.jpg'">
        </v-row>

        <v-row v-if="currentQuestion.type === 3 || currentQuestion.type === 4" justify="center">
          <div v-if="currentQuestion.text.indexOf('Referenzbereich (=Normalwert): Untergrenze') > -1">{{ '>=' }}</div>
          <div v-if="currentQuestion.text.indexOf('Referenzbereich (=Normalwert): Obergrenze') > -1">{{ '<=' }}</div>
          <input class="text-center" type="number"
                 v-model="entry"
                 :rules="[rules.numeric]"
                 style="background-color: #f2f4f7" :step="1"/>
        </v-row>

        <v-row justify="center" v-if="currentQuestion.type === 1">
          <v-radio-group
              v-if="currentQuestion.question_id !== '5ef834dc-c574-448a-be46-d0ecfab1e34e' && currentQuestion.question_id !== '4c032a91-74b8-4c93-9b7e-01c7ad227c17'"
              class="text-center"
              v-model="entry">
            <v-radio
                v-for="(answer, index) of answerTextTranslation"
                :key="index"
                :value="index"
                :label="answer"/>
            <!--<label :for="antwort">{{antwort}}</label> -->
          </v-radio-group>
          <v-autocomplete v-else class="text-center"
                          style="max-width: 500px !important"
                          v-model="entry"
                          :items="currentQuestion.answers"
          ></v-autocomplete>
        </v-row>
        <v-row v-if="currentQuestion.type === 5" justify="center">
          <v-date-picker
              color="green lighten-3"
              style="color: black"
              v-model="entry"
              :type="currentQuestion.question_id !== '05974690-ed8f-40a9-a0f8-6a04f8b2d6a8' ? 'date' : 'month'"
              class="mt-4 text-center text--primary"
              :locale="language"
              :max="dateMax"
          ></v-date-picker>
        </v-row>

        <v-row v-if="currentQuestion.type === 7" justify="center">
          <v-radio-group v-model="entry" class="text-center"
          >
            <v-radio
                :label="appTextsTranslations.yesNo[language] ? appTextsTranslations.yesNo[language][0]  : appTextsTranslations.yesNo['de'][0]"
                :value="true"
            ></v-radio>
            <v-radio
                :label="appTextsTranslations.yesNo[language] ? appTextsTranslations.yesNo[language][1]  : appTextsTranslations.yesNo['de'][1]"
                :value="false"
            ></v-radio>
          </v-radio-group>
        </v-row>

        <v-row v-if="currentQuestion.type === 8" justify="center">
          <v-file-input
              class="text-center"
              v-model="entry"
              accept="image/*"
              :label="questionTextTranslation"
          ></v-file-input>
        </v-row>

        <v-row justify="center" v-if="currentQuestion.type === 2">
          <v-form
              :rules="rules"
              class="text-center"
          >
            <v-checkbox
                class="text-center"
                type="checkbox"
                v-model="answersArray"
                v-for="(answer, index) of answerTextTranslation"
                :key="index"
                :value="index"
                :label="answer"/>
            <!-- <label :for="antwort">{{antwort}}</label> -->
          </v-form>
        </v-row>
        <!--<a-form-model-item v-if="currentQuestion.type === 7">
          <a-input v-model="form.desc" type="textarea" />
        </a-form-model-item>-->
        <div></div>

        <v-row v-if="(!valid && currentQuestion.type != 6) || showNextDisabled">
          <p style="color: red" v-if="appTextsTranslations.errorMessages[this.currentQuestion.type]">
            {{
              appTextsTranslations.errorMessages[this.currentQuestion.type][this.language] ? appTextsTranslations.errorMessages[this.currentQuestion.type][this.language] : appTextsTranslations.errorMessages[this.currentQuestion.type]['de']
            }}</p>
        </v-row>

        <v-row justify="center">
          <v-btn
              style="margin-top: 20px; margin-left: 20px"
              @click="oneBack" v-if="this.formerQuestionsList.length > 0 && this.currentQuestion.type < 9">
            {{
              appTextsTranslations.back[language] ? appTextsTranslations.back[language] : appTextsTranslations.back['de']
            }}
          </v-btn>
          <v-btn
              v-if="currentQuestion.type != 9 && !currentQuestionIsLastQuestion"
              style="margin-top: 20px; margin-left: 20px"
              class="success"
              @click="onSubmit"
              :disabled="showNextDisabled || !valid ||
              (currentQuestion.type != 2 && currentQuestion.type != 7 && currentQuestion.type != 6 && this.entry === null)
              || (this.answersArray.length > 2 && this.currentQuestion.question_id === '5ef834dc-c574-448a-be46-d0ecfab1e34e')
              || (currentQuestion.type === 1 && this.entry === null) || (currentQuestion.type === 7 && this.entry === null)
|| (currentQuestion.question_id === '75ea0a9e-b16a-4a60-948d-82834675d388' && this.answersArray.length < 1)"
          >
            {{
              appTextsTranslations.next[language] ? appTextsTranslations.next[language] : appTextsTranslations.next['de']
            }}
          </v-btn>
          <v-btn
              style="margin-top: 20px; margin-left: 20px"
              v-if="currentQuestionIsLastQuestion" type="primary" @click="toResults">
            {{
              appTextsTranslations.finished[language] ? appTextsTranslations.finished[language] : appTextsTranslations.finished['de']
            }}
          </v-btn>
        </v-row>
        <v-row justify="center" style="margin-top: 20px">
          <v-btn
              class="warning" style="color: white; margin-top: 20px; margin-left: 20px" @click="showHelp = true">
            {{
              appTextsTranslations.help[language] ? appTextsTranslations.help[language] : appTextsTranslations.help['de']
            }}
          </v-btn>
          <v-btn
              style="margin-top: 20px; margin-left: 20px" @click="refreshpage()">
            {{
              appTextsTranslations.reloadpage[language] ? appTextsTranslations.reloadpage[language] : appTextsTranslations.reloadpage['de']
            }}
          </v-btn>
        </v-row>
        <div></div>
        <!--<a-form-model-item>
          <a-button type="primary" @click="onSubmit"> Speichern </a-button>
        </a-form-model-item> -->
        <v-progress-linear
            style="margin-top: 50px"
            v-model="percentageFinished"
        />
        <v-row justify="center" style="margin-top: 30px">
          <p class="text-center">
            {{
              appTextsTranslations.privacy[language] ? appTextsTranslations.privacy[language] : appTextsTranslations.privacy['de']
            }}</p>
        </v-row>
      </v-col>
      <v-dialog
          v-model="showResults"
          dismissable
          width="80%"
      >
        <v-card class="text-center">
          <v-card-title>
            Ihre Angaben
            <v-spacer/>
            <v-icon
                aria-label="Close"
                @click="showResults = false"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text
              align="center"
              style="width: 80%; margin: auto"
          >
            <Results/>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showHelp"
          dismissable
          width="80%"
      >
        <v-card class="text-center">
          <v-card-title>
            <v-spacer/>
            <v-icon
                aria-label="Close"
                @click="showHelp = false"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text
              align="center"
              style="width: 80%; margin: auto"
          >
            <v-row v-if="this.formerQuestionsList.length > 0" justify="center">
              <v-btn
                  class="primary" style="color: white; margin-top: 20px; margin-left: 20px" @click="showResults = true">
                EINGABEN ALS LISTE ANSEHEN
              </v-btn>
            </v-row>
            <v-row v-if="formerQuestionsList.length > 0 && this.currentQuestion.type < 9" justify="center">
              <v-select
                  class="text-center"
                  placeholder="Zu früheren Fragen zurück"
                  style="max-width: 50%"
                  :items="formerQuestionsList"
                  :item-value="'index'"
                  v-model="questionIndex"
              >
                {{ question.text }}
              </v-select>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import jsonLogic from 'json-logic-js'
import {uuid} from 'vue-uuid'
import Ar from '../../src/components/layout/flags/Ar.vue'
import Cs from '../../src/components/layout/flags/Cs.vue'
import De from '../../src/components/layout/flags/De.vue'
import En from '../../src/components/layout/flags/En.vue'
import Es from '../../src/components/layout/flags/Es.vue'
import Fr from '../../src/components/layout/flags/Fr.vue'
import Hr from '../../src/components/layout/flags/Hr.vue'
import It from '../../src/components/layout/flags/It.vue'
import Pl from '../../src/components/layout/flags/Pl.vue'
import Pt from '../../src/components/layout/flags/Pt.vue'
import Ro from '../../src/components/layout/flags/Ro.vue'
import Ru from '../../src/components/layout/flags/Ru.vue'
import Tr from '../../src/components/layout/flags/Tr.vue'
import Nl from '../../src/components/layout/flags/Nl.vue'
import Results from '../views/Results'
import CryptoJS from 'crypto-js'
import axios from '../plugins/axios'

export default {
  components: {
    De, Ar, Cs, En, Es, Fr, Hr, It, Pl, Pt, Ro, Ru, Tr, Nl,
    Results,
  },
  mounted() {
    if(this.$route.query.adminuuid && this.$route.query.adminuuid === 'c914eeba-b202-4642-a553-132c5edfd5a7') {
      this.uuid = uuid.v4()
    } else {
      this.startAuth(this.$route.query.uuid)
    }
    this.fillStateWithLocalStorage()
  },
  data() {
    return {
      userpassword: null,
      showCommentSidebar: false,
      showHelp: false,
      showResults: false,
      adminUuid: 'c914eeba-b202-4642-a553-132c5edfd5a7',
      uuid: null,
      authError: '',
      answersArray: [],
      valid: true,
      secret: "123#$%",
      appTextsTranslations: {
        reloadpage: {
          'de': 'FORMULAR NEU STARTEN',
          'fr': 'RECOMMENCER',
          'en': 'RELOAD FORM',
          'tr': 'FORMU YENİDEN BAŞLAT',
          'ru': 'ФОРМА ПЕРЕЗАГРУЗКИ',
          'ar': 'استمارة إعادة التشغيل',
          'es': 'FORMULARIO DE REINICIO',
          'pt': 'REINICIAR FORMULÁRIO',
          'it': 'MODULO DI RIAVVIO',
          'pl': 'PONOWNIE URUCHOM FORMULARZ',
          'cz': 'RESTARTOVÁ FORMA',
          'hi': 'रीस्टार्ट फॉर्म',
          'nl': 'HERSTART FORMULIER'
        },
        title: {
          'de': 'Formular zur Erhebung der Immunität',
          'fr': 'Enquête sur l´immunité contre le Covid',
          'en': 'Survey on immunity against Covid',
          'tr': 'Bağışıklık Değerlendirme Formu',
          'ru': 'Форма оценки иммунитета',
          'ar': 'استمارة تقييم المناعة',
          'es': 'Formulario de evaluación de inmunidad',
          'pt': 'Formulário de Avaliação de Imunidade',
          'it': 'Modulo di valutazione dell\'immunità',
          'pl': 'Formularz oceny odporności',
          'cz': 'Formulář pro posouzení imunity',
          'hi': 'प्रतिरक्षा मूल्यांकन प्रपत्र',
          'nl': 'Immuniteitsbeoordelingsformulier'
        },
        next: {
          'de': 'WEITER',
          'fr': 'PROCHAINE QUESTION',
          'en': 'NEXT',
          'tr': 'DEVAM EDIN',
          'ru': 'ДАЛЬШЕ',
          'ar': 'متابعة',
          'es': 'MÁS LEJOS',
          'pt': 'AVANÇAR',
          'it': 'ULTERIORE',
          'pl': 'DALEJ',
          'cz': 'DÁLE',
          'hi': 'आगे',
          'nl': 'VERDER'
        },
        back: {
          'de': 'ZURÜCK',
          'fr': 'QUESTION PRECEDENTE',
          'en': 'NEXT',
          'tr': 'GERIYE GIDIN',
          'ru': 'ВОЗВРАЩЕНИЕ',
          'ar': 'إرجاع',
          'es': 'REGRESO',
          'pt': 'RETORNA',
          'it': 'RESTITUZIONE',
          'pl': 'POWRÓT',
          'cz': 'VRÁTIT SE',
          'hi': 'वापसी',
          'nl': 'OPBRENGST'
        },
        privacy: {
          'de': 'Wir verschlüsseln folgende Daten bei der Übersendung an unseren Server mit Passwort (hashen) und speichern sie nur verschlüsselt (Schutz im Falle eines Angriffs): Laborbogen, sowie (diese Daten werden nur erhoben, wenn Sie eine Immunitätsbescheinigung wollen) Name, Anschrift, Personalausweisnummer',
          'en': 'We hash (secure with a password) the following data for transmission and saving on our server (to prevent damage in case of hack): laboratory findings, as well as (these data are only required if you request a proof of immunity)',
          'fr': 'Nous cryptons les données suivantes lorsqu\'elles sont envoyées à notre serveur avec un mot de passe (hash) et ne les enregistrons que sous forme cryptée (protection en cas d\'attaque) : Fiche laboratoire, ainsi que (ces données ne sont collectées que si vous le souhaitez un certificat d\'immunité) nom, adresse, numéro de carte d\'identité',
          'tr': 'Sunucumuza bir şifre (hash) ile gönderildiğinde aşağıdaki verileri şifreliyoruz ve sadece şifreli olarak saklıyoruz (saldırı durumunda koruma): Laboratuvar sayfası ve (bu veriler sadece isterseniz toplanır) bağışıklık sertifikası) adı, adresi, kimlik numarası',
          'ru': 'Мы шифруем следующие данные, когда они отправляются на наш сервер с паролем (хешем), и сохраняем их только в зашифрованном виде (защита в случае атаки): Лабораторный лист, а также (эти данные собираются, только если вы хотите свидетельство о неприкосновенности) имя, адрес, номер удостоверения личности',
          'ar': 'نقوم بتشفير البيانات التالية عند إرسالها إلى خادمنا بكلمة مرور (تجزئة) وحفظها فقط في شكل مشفر (الحماية في حالة وقوع هجوم): ورقة المختبر ، وكذلك (يتم جمع هذه البيانات فقط إذا أردت شهادة حصانة) الاسم والعنوان ورقم بطاقة الهوية',
          'es': 'Ciframos los siguientes datos cuando se envían a nuestro servidor con una contraseña (hash) y solo los guardamos en forma encriptada (protección en caso de ataque): Ficha de laboratorio, así como (estos datos solo se recopilan si se desea un certificado de inmunidad) nombre, dirección, número de cédula de identidad',
          'pt': 'Criptografamos os seguintes dados quando são enviados ao nosso servidor com uma senha (hash) e só os salvamos de forma criptografada (proteção em caso de ataque): Ficha de laboratório, bem como (esses dados só são coletados se você quiser um certificado de imunidade) nome, endereço, número da carteira de identidade',
          'it': 'Crittografiamo i seguenti dati quando vengono inviati al nostro server con una password (hash) e li salviamo solo in forma crittografata (protezione in caso di attacco): Foglio di laboratorio, nonché (questi dati vengono raccolti solo se lo desideri un certificato di immunità) nome, indirizzo, numero di carta d\'identità',
          'pl': 'Szyfrujemy następujące dane przesyłane na nasz serwer hasłem (hash) i zapisujemy je tylko w postaci zaszyfrowanej (zabezpieczenie na wypadek ataku): Arkusz laboratoryjny, a także (te dane są zbierane tylko na życzenie zaświadczenie o nietykalności) imię i nazwisko, adres, numer dowodu osobistego',
          'cz': 'Následující data zašifrujeme, když jsou odeslána na náš server s heslem (hash), a uložíme je pouze v šifrované podobě (ochrana v případě útoku): Laboratorní list, stejně jako (tato data jsou shromažďována pouze pokud chcete certifikát imunity) jméno, adresa, číslo občanského průkazu',
          'hi': 'हम निम्नलिखित डेटा को एन्क्रिप्ट करते हैं जब इसे हमारे सर्वर पर पासवर्ड (हैश) के साथ भेजा जाता है और इसे केवल एन्क्रिप्टेड रूप में सहेजा जाता है (हमले की स्थिति में सुरक्षा): प्रयोगशाला शीट, साथ ही (यह डेटा केवल तभी एकत्र किया जाता है जब आप चाहते हैं एक प्रतिरक्षा प्रमाण पत्र) नाम, पता, पहचान पत्र संख्या',
          'nl': 'We versleutelen de volgende gegevens wanneer ze met een wachtwoord (hash) naar onze server worden verzonden en slaan ze alleen versleuteld op (bescherming bij een aanval): Laboratoriumblad, evenals (deze gegevens worden alleen verzameld als u wilt een immuniteitscertificaat) naam, adres, identiteitskaartnummer'
        },
        help: {
          'de': 'HILFE',
          'fr': 'BESOIN D´AIDE',
          'en': 'HELP',
          'tr': 'YARDIM',
          'ru': 'ПОМОЩЬ',
          'ar': 'يساعد',
          'es': 'AYUDA',
          'pt': 'AJUDA',
          'it': 'AIUTO',
          'pl': 'WSPARCIE',
          'cz': 'POMOC',
          'hi': 'मदद',
          'nl': 'HELPEN'
        },
        finished: {
          'de': 'FERTIG',
          'fr': 'FINIR',
          'en': 'FINISH',
          'tr': 'TAMAMLAMAK',
          'ru': 'СДЕЛАНО',
          'ar': 'انتهى',
          'es': 'HECHO',
          'pt': 'FEITO',
          'it': 'FATTO',
          'pl': 'GOTOWE',
          'cz': 'HOTOVO',
          'hi': 'किया हुआ',
          'nl': 'GEDAAN'
        },
        yesNo: {
          'de': ['Ja', 'Nein'],
          'en': ['Yes', 'No'],
          'fr': ['Oui', 'Non'],
          'tr': ['Evet', 'Hayir'],
          'ru': ['Да', 'нет'],
          'ar': ['نعم', 'لا'],
          'es': ['Sí', 'No'],
          'pt': ['Sim', 'Não'],
          'it': ['Si', 'No'],
          'pl': ['Tak', 'Nie'],
          'cz': ['Ano', 'Ne'],
          'hi': ['हाँ', 'नही'],
          'nl': ['Ja', 'Nee']
        },
        errorMessages: {
          6: {
            'de': 'Feld darf nicht leer sein',
            'en': 'Field must not be empty',
            'fr': 'La case ne peut pas être vide',
            'tr': 'Alan boş olamaz',
            'ru': 'Поле не может быть пустым',
            'ar': 'لا يمكن أن يكون الحقل فارغًا',
            'es': 'El campo no puede estar vacío',
            'pt': 'O campo não pode estar vazio',
            'it': 'Il campo non può essere vuoto',
            'pl': 'Pole nie może być puste',
            'cz': 'Pole nemůže být prázdné',
            'hi': 'फ़ील्ड खाली नहीं हो सकता',
            'nl': 'Veld mag niet leeg zijn'
          },
          3: {
            'de': 'Muss eine Zahl ein, mit Punkt statt Komma, und keine Tausendertrenner. Beispiel: 2000.34',
            'en': 'Must be a number, with dot instead of comma, and no thousand separators, e.g. 2000.34',
            'fr': 'Doit être un nombre, avec un point au lieu d\'une virgule, et pas de séparateurs de milliers. Exemple : 2000.34',
            'tr': 'Virgül yerine nokta içeren ve bin ayırıcı içermeyen bir sayı olmalıdır. Örnek: 2000.34',
            'ru': 'Должно быть числом с точкой вместо запятой и без разделителей тысяч. Пример: 2000.34',
            'ar': 'يجب أن يكون رقمًا بنقطة بدلاً من فاصلة ، ولا يوجد آلاف الفواصل. مثال: 2000.34',
            'es': 'Debe ser un número, con un punto en lugar de una coma y sin separadores de miles. Ejemplo: 2000.34',
            'pt': 'Deve ser um número, com um ponto em vez de uma vírgula e sem separadores de milhar. Exemplo: 2.000,34',
            'it': 'Deve essere un numero, con un punto anziché una virgola e senza separatori delle migliaia. Esempio: 2000.34',
            'pl': 'Musi być liczbą z kropką zamiast przecinka i bez separatorów tysięcy. Przykład: 2000,34',
            'cz': 'Musí to být číslo s tečkou místo čárky a bez tisíců oddělovačů. Příklad: 2000.34',
            'hi': 'अल्पविराम के बजाय एक अवधि के साथ एक संख्या होनी चाहिए, और कोई हजार विभाजक नहीं होना चाहिए। उदाहरण: २०००.३४',
            'nl': 'Moet een getal zijn, met een punt in plaats van een komma, en geen scheidingstekens voor duizendtallen. Voorbeeld: 2000.34'
          },
          4: {
            'de': 'Muss eine Zahl ein, mit Punkt statt Komma, und keine Tausendertrenner. Beispiel: 2000.34',
            'en': 'Must be a number, with dot instead of comma, and no thousand separators, e.g. 2000.34',
            'fr': 'Doit être un nombre, avec un point au lieu d\'une virgule, et pas de séparateurs de milliers. Exemple : 2000.34',
            'tr': 'Virgül yerine nokta içeren ve bin ayırıcı içermeyen bir sayı olmalıdır. Örnek: 2000.34',
            'ru': 'Должно быть числом с точкой вместо запятой и без разделителей тысяч. Пример: 2000.34',
            'ar': 'يجب أن يكون رقمًا بنقطة بدلاً من فاصلة ، ولا يوجد آلاف الفواصل. مثال: 2000.34',
            'es': 'Debe ser un número, con un punto en lugar de una coma y sin separadores de miles. Ejemplo: 2000.34',
            'pt': 'Deve ser um número, com um ponto em vez de uma vírgula e sem separadores de milhar. Exemplo: 2.000,34',
            'it': 'Deve essere un numero, con un punto anziché una virgola e senza separatori delle migliaia. Esempio: 2000.34',
            'pl': 'Musi być liczbą z kropką zamiast przecinka i bez separatorów tysięcy. Przykład: 2000,34',
            'cz': 'Musí to být číslo s tečkou místo čárky a bez tisíců oddělovačů. Příklad: 2000.34',
            'hi': 'अल्पविराम के बजाय एक अवधि के साथ एक संख्या होनी चाहिए, और कोई हजार विभाजक नहीं होना चाहिए। उदाहरण: २०००.३४',
            'nl': 'Moet een getal zijn, met een punt in plaats van een komma, en geen scheidingstekens voor duizendtallen. Voorbeeld: 2000.34'
          },/*
          5: {
            'de': 'Datum ist nicht zulässig: Corona-bezogene Daten müssen nach Beginn der Pandemie sein; Geburtsdatum muss mehr als 18 Jahre zurückliegen',
            'en': 'Date is invalid: Covid-related events must be after begin of pandemy; Birth date must be older than 18 years'
          }*/
        },
      },
      language: 'de',
      formerQuestion: null,
      showSidebar: false,
      openKeys: ['sub1', 'sub2'],
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      formerQuestionsList: [],
      question: {
        question_id: 'bla',
        type: 1,
        text: 'Some question text',
        answers: ['dummy', 'dummy2'],
        rules: [],
      },
      entry: null,
      questionIndex: [0],
      form: {
        name: '',
        region: undefined,
        date1: undefined,
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
    }
  },
  computed: {
    dateMax() {
      let today = new Date();
      return today.toISOString()
    },
    dateMin() {
      var hundredYearsBeforeNow = new Date();
      hundredYearsBeforeNow.setFullYear(hundredYearsBeforeNow.getFullYear() - 18);
      if(this.currentQuestion.question_id === '504a4fa9-3114-4345-97f4-f2ece6b00fc3') {
        return hundredYearsBeforeNow.toISOString().split('T')[0]
      } else return '2021-01-01'
    },
    rules() {
      let ruleObj = {
        required: (value) => {
          if((value && value.length > 0) || (this.entry && this.entry.length > 0) || this.currentQuestion.question_id === '501d5de3-853d-4948-b359-00490c6ab5aa') {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.valid = true
            return true
          } else {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            if(!this.entry) {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.valid = false
              return 'Feld darf nicht leer sein'
            } else return true
          }
        },
        numeric: (value) => {
          if(!isNaN(value)) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.valid = true
            return true
          } else {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.valid = false
            return 'Muss eine Zahl ein, mit Punkt statt Komma, und keine Tausendertrenner'
          }
        },
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      }
      return ruleObj
    },
    nextButtonTranslation() {
      let defaultText = "WEITER"
      if(this.language && this.language != 'de') {
        if(this.language === 'fr') {
          defaultText = 'PROCHAINE QUESTION'
        }
        if(this.language === 'en') {
          defaultText = 'NEXT'
        }
      }
      return defaultText
    },
    backButtonTranslation() {
      let defaultText = "ZURÜCK"
      if(this.language && this.language != 'de') {
        if(this.language === 'fr') {
          defaultText = 'EN ARRIERE'
        }
        if(this.language === 'en') {
          defaultText = 'BACK'
        }
      }
      return defaultText
    },
    questionTextTranslation() {
      let defaultText = this.currentQuestion.text
      if(this.currentQuestion.translation && this.currentQuestion.translation.text) {
        if(this.currentQuestion.translation.text[this.language]) {
          defaultText = this.currentQuestion.translation.text[this.language]
        }
      }
      return defaultText
    },
    commentTextTranslation() {
      let defaultText = this.currentQuestion.commentText
      if(this.currentQuestion.translation && this.currentQuestion.translation.commentText) {
        if(this.currentQuestion.translation.commentText[this.language]) {
          defaultText = this.currentQuestion.translation.commentText[this.language]
        }
      }
      return defaultText
    },
    answerTextTranslation() {
      let defaultText = this.currentQuestion.answers
      if(this.currentQuestion.translation && this.currentQuestion.translation.answers) {
        if(this.currentQuestion.translation.answers[this.language]) {
          defaultText = this.currentQuestion.translation.answers[this.language]
        }
      }
      return defaultText
    },
    isMandatory() {
      let response = false
      if(this.currentQuestion.required && (this.currentQuestion.required === true || parseInt(this.currentQuestion.required) === 1)) {
        response = true
      }
      return response
    },
    showNextDisabled() {
      let response = false
      if(this.isMandatory && (this.currentQuestion.required && this.entry == null && this.currentQuestion.type != 7)) {
        response = true
      }
      return response
    },
    percentageFinished() {
      const numberOfBlocks = this.questionsListParsed.length
      const currentIndex = this.questionIndex[0] + 1
      let percentage = Math.round(100 * (currentIndex / numberOfBlocks))
      if(percentage > 99) {
        percentage = 99
      }
      return percentage
    },
    currentQuestion() {
      return this.calculateCurrentQuestion(this.questionIndex)
    },
    nextQuestionIndex() {
      const questionIndexCopy = [...this.questionIndex]
      let questionIndexResult = []
      // try increment last counter
      questionIndexCopy[questionIndexCopy.length - 1] =
          questionIndexCopy[questionIndexCopy.length - 1] + 1
      console.log('TEST NEXT INDEX', questionIndexCopy)
      if(
          this.calculateCurrentQuestion(questionIndexCopy) &&
          this.calculateCurrentQuestion(questionIndexCopy).question_id
      ) {
        questionIndexResult = questionIndexCopy
      } else {
        return this.removeOneIndexAndCheck(questionIndexCopy)
      }
      return questionIndexResult
    },
    currentQuestionIsLastQuestion() {
      const calculatedNext = this.calculateCurrentQuestion(
          this.nextQuestionIndex
      )
      const isNotLast = calculatedNext && calculatedNext.question_id
      return !isNotLast
    },
    questionsListParsed() {
      return this.$store.state.questionsListParsed
    },
    questionUnnested() {
      const returnArray = []
      for(const obj of this.questionsListParsed) {
        this.nestedArrayPush(returnArray, obj)
      }
      return returnArray
    },
  },
  methods: {
    refreshpage() {
      window.localStorage.removeItem('questionindex')
      window.localStorage.removeItem('formerquestionslist');
      window.localStorage.removeItem('questionnaireresultswithcolumn');
      window.localStorage.removeItem('questionnaireresults');
      window.localStorage.removeItem('questionnaireresultspdf');
      this.$router.go()
    },
    fillLocalStorage() {
      if (this.uuid && this.uuid.length > 0) {
        window.localStorage.setItem('uuid', this.uuid);
      }
      if (this.questionIndex) {
        window.localStorage.setItem('questionindex', JSON.stringify(this.questionIndex));
      }
      if (this.formerQuestionsList) {
        window.localStorage.setItem('formerquestionslist', JSON.stringify(this.formerQuestionsList));
      }
      if (this.$store.state.questionnaireResultsWithColumn) {
        window.localStorage.setItem('questionnaireresultswithcolumn', JSON.stringify(this.$store.state.questionnaireResultsWithColumn));
      }
      if (this.$store.state.questionnaireResults) {
        window.localStorage.setItem('questionnaireresults', JSON.stringify(this.$store.state.questionnaireResults));
      }
      if (this.$store.state.questionnaireResultsPdf) {
        window.localStorage.setItem('questionnaireresultspdf', JSON.stringify(this.$store.state.questionnaireResultsPdf));
      }
    },
    fillStateWithLocalStorage() {
      if (window.localStorage.getItem('uuid') && window.localStorage.getItem('uuid').length > 0) {
        this.uuid = window.localStorage.getItem('uuid')
      }
      if (window.localStorage.getItem('questionindex')) {
        this.questionIndex = JSON.parse(window.localStorage.getItem('questionindex'))
      }
      if (window.localStorage.getItem('formerquestionslist')) {
        this.formerQuestionsList = JSON.parse(window.localStorage.getItem('formerquestionslist'))
      }
      if (window.localStorage.getItem('questionnaireresultswithcolumn')) {
        let questionnaireResultsWithColumn = {...JSON.parse(window.localStorage.getItem('questionnaireresultswithcolumn'))}
        this.$store.commit('setFormResultsWithColumn', questionnaireResultsWithColumn)
      }
      if (window.localStorage.getItem('questionnaireresults')) {
        let questionnaireResults = {...JSON.parse(window.localStorage.getItem('questionnaireresults'))}
        this.$store.commit('setFormResults', questionnaireResults)
      }
      if (window.localStorage.getItem('questionnaireresultspdf')) {
        let questionnaireResultsPdf = {...JSON.parse(window.localStorage.getItem('questionnaireresultspdf'))}
        this.$store.commit('setFormResultsForPdf', questionnaireResultsPdf)
      }
    },
    checkUserPassword() {
      if (this.userpassword === 'c914eeba-b202-4642-a553-132c5edfd5a7') {
        this.uuid = uuid.v4()
      } else {
        this.startAuth(this.userpassword)
      }
    },
    encrypted(payload) {
      return CryptoJS.AES.encrypt(payload, this.secret).toString();
    },
    decrypted(payload) {
      let bytes = CryptoJS.AES.decrypt(payload, this.secret);
      return bytes.toString(CryptoJS.enc.Utf8)
    },
    startAuth(uuid) {
      const self = this
      const postObj = {}
      postObj.uuid = uuid
      postObj.action = 'auth'
      axios.post(self.$store.state.url + 'api/edit.php', postObj).then((response) => self.showAuthIfCorrect(response, uuid))
    },
    showAuthIfCorrect(data, uuid) {
      console.log('RESPONSE', data)
      if(data.data && !data.data.includes('Fatal')) {
        this.uuid = uuid
      }
      this.fillStateWithLocalStorage()
    },
    oneBack() {
      const formerQuestionListCopy = [...this.formerQuestionsList]
      const element = formerQuestionListCopy[formerQuestionListCopy.length - 1]
      this.questionIndex = element.index
      if(element.value) {
        if(Array.isArray(element.value)) {
          this.answersArray = element.value
        } else {
          this.entry = element.value
        }
      }
      this.valid = true
    },
    dateIsAfterBeginOfPandemy(dateString) {
      const d = new Date(dateString)
      const beginnDate = new Date('2020-01-02')
      return d > beginnDate
    },
    vaccineWasThisYear(dateString) {
      const d = new Date(dateString)
      const beginnDate = new Date('2021-01-01')
      return d > beginnDate
    },
    returnToFormerQuestion() {
      this.questionIndex = this.formerQuestion
    },
    returnToOverview() {
      this.$emit('setStatus', 'overview')
    },
    toResults() {
      this.addCurrentQuestionToFormerQuestionList()
      if(!this.entry) {
        this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, false])
      } else {
        this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, this.entry])
      }
      this.$emit('setStatus', 'results')
    },
    returnItemsFromAnswersArray() {
      let itemList = ""
      for(let item of this.answersArray) {
        if(itemList.length > 0) {
          itemList = itemList + ',' + this.currentQuestion.answers[item]
        } else {
          itemList = this.currentQuestion.answers[item]
        }
      }
      return itemList
    },
    returnEntryStringFromRadioButtonEntry() {
      let returnValue = ""
      if(this.entry) {
        if(isNaN(this.entry)) {
          returnValue = this.entry
        } else {
          returnValue = this.currentQuestion.answers[this.entry]
        }
      }
      return returnValue
    },
    onSubmit() {
      if(this.valid) {
        if(this.currentQuestion.type !== 8) {
          this.addCurrentQuestionToFormerQuestionList()
        }
        if(!this.entry && this.currentQuestion.type != 2) {
          this.$store.dispatch('setFormResultsForPdf', [this.currentQuestion.text, "Nein"])

          this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, false])
          if(this.currentQuestion.api && this.currentQuestion.api.length > 0) {
            this.$store.dispatch('setFormResultsWithColumn', [this.currentQuestion.api, false])
          }
        } else {
          if(this.currentQuestion.api && this.currentQuestion.api.length > 0) {
            if(this.currentQuestion.type != 2) {
              this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, this.entry])
              if(this.currentQuestion.type === 1) {
                this.$store.dispatch('setFormResultsForPdf', [this.currentQuestion.text, this.returnEntryStringFromRadioButtonEntry()])
                this.$store.dispatch('setFormResultsWithColumn', [this.currentQuestion.api, this.returnEntryStringFromRadioButtonEntry()])
              } else {
                // TODO: HASH
                let res = this.entry
                if(this.currentQuestion.hash) {
                  res = this.encrypted(this.entry)
                }
                if(this.currentQuestion.type === 7) {
                  this.$store.dispatch('setFormResultsForPdf', [this.currentQuestion.text, "Ja"])
                } else {
                  this.$store.dispatch('setFormResultsForPdf', [this.currentQuestion.text, this.entry])
                }
                this.$store.dispatch('setFormResultsWithColumn', [this.currentQuestion.api, res])
              }
            } else {
              this.$store.dispatch('setFormResultsForPdf', [this.currentQuestion.text, this.returnItemsFromAnswersArray()])
              this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, this.answersArray])
              this.$store.dispatch('setFormResultsWithColumn', [this.currentQuestion.api, this.returnItemsFromAnswersArray()])
            }
          } else {
            if(this.currentQuestion.type != 2) {
              this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, this.entry])
            } else {
              this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, this.answersArray])
            }
          }
        }
        let self = this
        if(this.currentQuestion.type === 8) {
          let reader = new FileReader();
          reader.readAsDataURL(this.entry);
          let self = this
          let postObj = {}
          postObj.uuid = this.uuid
          postObj.action = 'insertFile'
          reader.onload = function() {
            let encryptedObj = self.encrypted(reader.result)
            postObj.file = encryptedObj
            axios.post(self.$store.state.url + 'api/edit.php', postObj).then((result) => console.log(result))
          };
        }
        this.answersArray = []
        this.entry = null
        this.toNextQuestion()
      }
    },
    nestedArrayPush(array, obj) {
      const objCopy = {...obj}
      delete objCopy.children
      array.push(objCopy)
      if(obj.children) {
        for(const child of obj.children) {
          this.nestedArrayPush(array, child)
        }
      }
    },
    calculateCurrentQuestion(indexArray) {
      if(this.questionsListParsed && this.questionsListParsed.length > 0) {
        let questionPart = [...this.questionsListParsed]
        for(let i = 0; i < indexArray.length; i++) {
          if(i < 1) {
            questionPart = this.questionsListParsed[indexArray[i]]
          } else {
            questionPart = {...questionPart}.children[indexArray[i]]
          }
        }
        return questionPart
      } else return {}
    },
    toNextQuestion() {
      this.questionIndex = [...this.nextQuestionIndex]
      const results = this.$store.state.questionnaireResults
      const newQuestion = {
        ...this.calculateCurrentQuestion(this.questionIndex),
      }
      if(newQuestion.rule_id && newQuestion.rule) {
        console.log('RULE')
        const rule = newQuestion.rule
        if(jsonLogic.apply(rule, results)) {
          console.log('ÜBERSPRINGEN')
          this.toNextQuestion()
        }
      }
      if(!this.currentQuestion.type) {
        this.goToNextChild()
      }
      const postObj = {}
      postObj.uuid = this.uuid
      let self = this
      if(this.currentQuestion.type === 9) {
        postObj.action = 'insertData'
        postObj.results = this.$store.state.questionnaireResultsWithColumn
        postObj.json = JSON.stringify(this.$store.state.questionnaireResultsWithColumn)
        console.log('POSTOBJ SHOW', postObj)
        axios.post(self.$store.state.url + 'api/edit.php', postObj).then((result) => console.log(result))

      }
      this.fillLocalStorage()
    },
    goToNextChild() {
      const currentQuestionIndex = [...this.questionIndex]
      const results = this.$store.state.questionnaireResults
      currentQuestionIndex.push(0)
      this.questionIndex = [...currentQuestionIndex]
      const newQuestion = {
        ...this.calculateCurrentQuestion(currentQuestionIndex),
      }
      if(newQuestion.rule_id && newQuestion.rule) {
        const rule = newQuestion.rule
        if(jsonLogic.apply(rule, results)) {
          this.toNextQuestion()
        }
      }
      if(!this.currentQuestion.type) {
        this.goToNextChild()
      }
    },
    addCurrentQuestionToFormerQuestionList() {
      const obj = {...this.currentQuestion}
      obj.index = [...this.questionIndex]
      if(this.currentQuestion.type === 2) {
        obj.value = this.answersArray
      } else {
        obj.value = this.entry
      }
      if(
          this.formerQuestionsList.filter(
              (listObj) => listObj.question_id === obj.question_id
          ).length < 1
      ) {
        this.formerQuestionsList.push(obj)
      }
    },
    removeOneIndexAndCheck(questionIndexCopy) {
      if(questionIndexCopy.length > 1) {
        questionIndexCopy.pop()
        questionIndexCopy[questionIndexCopy.length - 1] =
            questionIndexCopy[questionIndexCopy.length - 1] + 1
        if(
            this.calculateCurrentQuestion(questionIndexCopy) &&
            this.calculateCurrentQuestion(questionIndexCopy).question_id
        ) {
          return questionIndexCopy
        } else {
          this.removeOneIndexAndCheck(questionIndexCopy)
        }
      }
    },
  },
}
</script>
